import { Box, Dialog, DialogContent, IconButton, Typography } from '@mui/material';

import CloseIcon from '@mui/icons-material/Close';
import { useEffect, useState } from 'react';
import { useServerTranslation } from 'hooks/useServerTranslation';
import Login from '../Login/Login';
import ResetPassword from '../Login/components/ResetPassword';

type Props = {
    open: boolean;
    setOpen: (open: boolean) => void;
};

export default function LoginDialog({ open, setOpen }: Props) {
    const { t } = useServerTranslation();

    useEffect(() => {
        if (open) {
            setResetPasswordOpen(false);
        }
    }, [open]);

    const closeDialog = () => {
        setOpen(false);
    };

    const [resetPasswordOpen, setResetPasswordOpen] = useState(false);

    const openForgotPassword = () => {
        setResetPasswordOpen(true);
    };

    return (
        <Dialog open={open} onClose={closeDialog} maxWidth="xs" fullWidth>
            <DialogContent>
                <Box justifyContent="space-between" display="flex">
                    <Typography variant="h1" paddingBottom={4}>
                        {resetPasswordOpen ? t('user.reset-password') : t('menu.log-in')}
                    </Typography>
                    <IconButton onClick={closeDialog} sx={{ width: '30px', height: '30px', p: 0 }}>
                        <CloseIcon />
                    </IconButton>
                </Box>
                {resetPasswordOpen
                    ? <ResetPassword />
                    : <Login closeDialog={closeDialog} openForgotPassword={openForgotPassword} />}
            </DialogContent>
        </Dialog>
    );
}
